import React, { useLayoutEffect, useState } from 'react'
import { useRef } from 'react'
import { HintIcon } from '../../asset/icon/HintIcon'
//@ts-ignore
import s from './Hint.module.scss'


export const Hint = ({ ...props }) => {
    const { children } = props;

    const [isLoadImgStatus, setStatus] = useState(false)

    const hintRef = useRef(null)
    const hintIconRef = useRef(null)
    const popoverBodyRef: any = useRef(null)

    const [isVisibleHint, setVisibleHint] = useState(false)
    
    useLayoutEffect(() => {
        
        const maxWidthHint = 512;
        const indentOfIcon = 30;
        const indentHeaderHint = 54;
        const minPaddingHint = 20;


        const iconHint = hintIconRef;

        const popoverBody = popoverBodyRef.current;
        let wrapSection: any = document.querySelector("body");




        const icon = getOffsetProperty(iconHint.current);
        const page = getOffsetProperty(wrapSection);



        // let popoverBody = document.getElementById("popover-body");
        // let RIconIndent = Number(page.elementWidth) - Number(icon.elementWidth) - Number(icon.elementOffsetLeft);
        // let RHintIndent = Number(RIconIndent) - Number(icon.elementWidth) - Number(icon.elementOffsetLeft);
        let LHintIndent = Number(icon.elementOffsetLeft) + Number(icon.elementWidth) + Number(indentOfIcon);
        // let leftIndent = Number(icon.elementOffsetLeft) + Number(icon.elementWidth) + indentOfIcon;
        let topIndent = Number(icon.elementOffsetTop) - indentHeaderHint
        let maxWidth = Number(page.elementWidth) - LHintIndent - minPaddingHint;

        let hintWrap = document.createElement("div");
        hintWrap.id = "popover-wrap";
        hintWrap.className = "popover-wrap";
        hintWrap.style.top = `${topIndent}px`;
        hintWrap.style.left = `${LHintIndent}px`;

        let hintArrow = document.createElement("div");
        hintArrow.id = "popover-arrow";
        hintArrow.className = "popover-arrow";
        hintWrap.appendChild(hintArrow)

        let hintBox = document.createElement("div");
        hintBox.id = "popover-body";
        hintBox.className = "popover-body";
        hintBox.appendChild(popoverBody)
        hintWrap.appendChild(hintBox)


        if (maxWidth < maxWidthHint) {
            hintWrap.style.maxWidth = `${maxWidth}px`;
            popoverBody.style.maxWidth = `${maxWidth - 68}px`;
        }

        popoverBody.className = " ";

        let hintImg = hintBox.querySelectorAll('img');
        if (hintImg.length > 0) {
            hintImg[0].onload = function () {
                setStatus(true)

            }
        }

        if (isVisibleHint) {
            document.body.append(hintWrap);
        } else {
            let popoverBody: any = document.getElementById("popover-wrap");
            if (popoverBody) {
                popoverBody.parentNode.removeChild(popoverBody);
            }
        }

        if (!!isVisibleHint) {

            let hint = getOffsetProperty(hintWrap);
            let pageHeight = Number(page.elementHeight) - minPaddingHint;
            let pageWidth = Number(page.elementWidth) - (2 * minPaddingHint);

            if (pageHeight < hint.elementOfBottom) {

                let bottomPadding: any = Number(pageHeight) - Number(hint.elementOfBottom);
                console.log(bottomPadding);

                hintWrap.style.top = `${Number(hint.elementOffsetTop) + bottomPadding}px`;
                hintArrow.style.top = `${Number(40) + Math.abs(bottomPadding)}px`;
            }

            console.log(pageWidth);
            console.log(hint.elementWidth);

            if (pageWidth < hint.elementWidth) {


                hintWrap.style.maxWidth = `${Number(pageWidth) - minPaddingHint}px`;
            }


        }

    }, [isLoadImgStatus, isVisibleHint])


    return (
        <div ref={hintRef} className={s.hint}>
            <div ref={hintIconRef} className={s.icon} onMouseEnter={() => {

                console.log('12');

                setVisibleHint(true)
            }} onMouseLeave={() => {
                console.log('34');
                setVisibleHint(false)
            }} >
                <HintIcon />
            </div>
            <div ref={popoverBodyRef} className={s.popoverBody}>{children} </div>


        </div>
    )
}


//     @Input() hint: string;

//     showText: string;
//     showPopover = false;
//     transX = 0;
//     constructor() { }

//     ngOnInit(): void {

//     }

//     @ViewChild('hindBox')

//     hindBox: ElementRef;

//     openPopver(hint) {

//       this.showText = hint;
//       this.showPopover = true;
//     }
//     closePopover(hint) {
//       this.showText = hint;
//       this.showPopover = false;
//     }

//     ngAfterViewChecked() {


//       if (this.showText === this.hint) {

//         if (this.showPopover) {

//           const hint = this.hindBox.nativeElement;
//           const iconHint = hint.getElementsByTagName('img')[0];
//           const popoverArrow = hint.querySelectorAll('.popover-arrow')[0];


//           let wrapSection: HTMLElement = document.querySelector(".configurator_module");
//           let mainSection: HTMLElement = hint.closest('.hint_wrap')

//           const iconProp = getOffsetProperty(iconHint);
//           const wrapSectionProp = getOffsetProperty(wrapSection);
//           const mainSectionProp = getOffsetProperty(mainSection);

//           const widthLeft = Number(iconProp.elementOffsetLeft);
//           const widthRight = Number(wrapSectionProp.elementWidth) - Number(iconProp.elementOffsetLeft) - Number(iconProp.elementWidth);

//           let standartPositionTop = Number(iconProp.elementOffsetTop) + Number(iconProp.elementHeight) + 18;

//           let hintBox = document.createElement("div");
//           hintBox.id = "popover-body";
//           hintBox.dataset.hint = this.hint;
//           hintBox.className = "popover-body";
//           hintBox.innerHTML = `${this.hint}`;
//           hintBox.style.top = `${standartPositionTop}px`;
//           document.body.append(hintBox);

//           const widthPol = hintBox.offsetWidth / 2 + 15;

//           if (widthLeft < widthPol) {
//             const transX: Number = widthPol - widthLeft + widthLeft

//             hintBox.style.left = `${transX}px`;
//           } else if (widthRight < widthPol) {
//             const transX: Number = Number(iconProp.elementOffsetLeft) - widthPol + widthRight
//             hintBox.style.left = `${transX}px`;
//           } else {
//             hintBox.style.left = `${iconProp.elementOffsetLeft}px`;
//           }


//           let heightMainSection = Number(mainSectionProp.elementHeight);
//           let bodyHeight = Number(hintBox.offsetHeight);

//           if (heightMainSection < bodyHeight + standartPositionTop - Number(mainSectionProp.elementOffsetTop) && mainSectionProp.elementOffsetTop > bodyHeight) {
//             hintBox.style.top = `${standartPositionTop - Number(iconProp.elementHeight) - 18 - 18 - hintBox.offsetHeight}px`;
//             popoverArrow.style.top = 'unset';
//             popoverArrow.style.bottom = `20px`;
//           }

//         } else {


//         }
//       }
//     }

//   }

function getOffsetProperty(element: any) {
    const width: Number = element.offsetWidth;
    const height: Number = element.offsetHeight;
    const top: Number = element.getBoundingClientRect().top;
    const left: Number = element.getBoundingClientRect().left;
    const right: Number = element.getBoundingClientRect().right;
    const bottom: Number = element.getBoundingClientRect().bottom;

    return { elementWidth: width, elementHeight: height, elementOffsetTop: top, elementOffsetLeft: left, elementRight: right, elementOfBottom: bottom }
}
